import React, { Component } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import { fetchConstructionList } from 'actions/ConstructionActions';
import { prepareCreateShiftRecord } from 'actions/UserActions';
import { createPositionOptions, createWorkCategoryOptions} from './createPositionptions';

const DateRange = ({date, dayLast}) => {
  let dateForMutate = moment(date.format("YYYY-MM-DD"), "YYYY-MM-DD");
  dateForMutate.add(dayLast - 1, 'days');

  return (
    <div className="date">
      {date.format("YYYY-MM-DD")}
      {dayLast > 1 && " 至 " + dateForMutate.format("YYYY-MM-DD")}
    </div>
  )
}
export default class CreateShiftModal extends Component {
  constructor(props) {
    super(props);

    let {sid, siteList, user} = this.props;
    const maxYear = Math.max(
      ...siteList.filter(s => s.get('status') === 0)
          .map(s => s.get('year'))
      )
    console.debug(user);
    this.state = {
      years: siteList.filter(s => s.get('status') === 0 && s.get('year') > 0).map(s => s.get('year')).reduce((s, y) => {
        if (!s.includes(y)) s.push(y)
        return s;
      }, []).sort().reverse(),
      selectedYear: maxYear,
      selectedCid: siteList.getIn([
                    siteList.findIndex((site) => site.get('status') ===0 && (site.get('year') === maxYear || site.get('year') === 0)),
                    'cid']),
      mornShift: (sid === 0? true: false),
      aftnShift: (sid === 1? true: false),
      otShift: (sid === 2? true: false),
      tillEOM: false,
      dayLast: 1,
      confirming: false,
      selectedPid: user.get('role')
    }
  }

  activeConfirm = () => {
    let {mornShift, aftnShift, otShift} = this.state;

    this.setState({
      confirming: mornShift || aftnShift || otShift
    })
  }

  dismissConfirm = () => {
    this.setState({
      confirming: false
    })
  }

  handleSelectYear = (e) => {
    this.setState({
      selectedYear: +e.target.value
    })
  }

  handleSelectCid = (e) => {
    this.setState({
      selectedCid: +e.target.value
    })
  }

  handleSelectedPid = (e) => {
    this.setState({
      selectedPid: +e.target.value
    })
  }

  componentDidMount() {
    this.props.dispatch(fetchConstructionList());
  }

  switchShiftSelection = (name) => {
    this.setState({
      [name]: !this.state[name]
    })
  }

  handleTillEOM = () => {
    let {tillEOM, dayLast} = this.state;
    let {date} = this.props;
    let dayLeft = date.daysInMonth() - date.format('DD') + 1;

    this.setState({
      tillEOM: !tillEOM,
      dayLast: (!tillEOM? dayLeft: dayLast)
    })
  }

  handleDayLastChange = (e) => {
    this.setState({
      dayLast: e.target.value
    })
  }

  handleCreateShiftRecord = () => {
    this.props.dispatch(prepareCreateShiftRecord({date:this.props.date, ...this.state}));
    this.props.dismiss();
  }

  render() {
    let {dismiss, siteList, positionList, date, user} = this.props;
    let {years, selectedYear, selectedCid, mornShift, aftnShift, otShift, tillEOM, dayLast, confirming, selectedPid} = this.state;

    return (
      <Modal.Dialog className="schedule__create__modal">
        <Modal.Header>
          <Modal.Title>
            編更
          </Modal.Title>
        </Modal.Header>
        {(confirming?
          <Modal.Body className="confirm-form">
            <div className="user">
              {user}
            </div>
            <div className="site">
              {siteList.find((site) => site.get('cid') === selectedCid).get('name')}
            </div>
            <DateRange date={date} dayLast={dayLast} />
            <div className="shift-label">
              {mornShift &&
                <span className="label label-primary">上午</span>}
              {aftnShift &&
                <span className="label label-primary">下午</span>}
              {otShift &&
                <span className="label label-primary">加班</span>}
            </div>
          </Modal.Body>
          :
          <Modal.Body>
            <select value={selectedYear} onChange={this.handleSelectYear} className="form-control">
              {years.map(year => {
                return <option key={year} value={year}>工程年份-{year}</option>
              })}
            </select>
            <select value={selectedCid} onChange={this.handleSelectCid} className="form-control">
              {siteList
                .filter((site) => {
                  return site.get('status') === 0 && (site.get('year') === 0 || site.get('year') === selectedYear)
                })
                .map((site) => (
                  <option key={site.get('name')} value={site.get('cid')}>{site.get('name')}</option>
                ))
              }
            </select>
            <select value={selectedPid} onChange={this.handleSelectedPid} className="form-control">
              {createWorkCategoryOptions(positionList)}
              {createPositionOptions(positionList)}
            </select>
            <div className="date">
              <label>
                {date.format("YYYY-MM-DD")}
              </label>
            </div>
            <div className="btn-group" role="group">
              <button
                className={"btn btn-" + (mornShift? "primary": "default")}
                onClick={() => this.switchShiftSelection('mornShift')}
              >
                上午
              </button>
              <button
                name="aftnShift"
                className={"btn btn-" + (aftnShift? "primary": "default")}
                onClick={() => this.switchShiftSelection('aftnShift')}
              >
                下午
              </button>
              <button
                name="otShift"
                className={"btn btn-" + (otShift? "primary": "default")}
                onClick={() => this.switchShiftSelection('otShift')}
              >
                加班
              </button>
            </div>
            <div className="form-inline date-section">
              為期
              <input
                type="text"
                className="form-control"
                placeholder="日數"
                value={dayLast}
                onChange={this.handleDayLastChange}
                disabled={tillEOM}/>
              日
              <button
                className={"btn btn-" + (tillEOM? "primary": "default")}
                onClick={this.handleTillEOM}
              >
                直至月底
              </button>
            </div>
          </Modal.Body>
        )}
        {(confirming?
          <Modal.Footer>
            <button className="btn btn-primary" onClick={this.handleCreateShiftRecord}>確定</button>
            <button className="btn btn-default" onClick={this.dismissConfirm}>取消</button>
          </Modal.Footer>
          :
          <Modal.Footer>
            <button className="btn btn-primary" onClick={this.activeConfirm}>儲存</button>
            <button className="btn btn-default" onClick={dismiss}>關閉</button>
          </Modal.Footer>
        )}
      </Modal.Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Schedule/CreateShiftModal.js